import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';

/** Решает задачу синхронизации ширин колонок в двух отдельных css-grid элементах */
export const useObserveColumnsWidths = () => {
  const [widths, setWidths] = React.useState<null | number[]>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const rowRef = React.useRef<HTMLDivElement>(null);
  const animationFrameRef = React.useRef<number>(0);

  /** При изменении размеров ячеек сохранит ширины в стейт */
  const ro = React.useMemo(
    () =>
      new ResizeObserver(() => {
        animationFrameRef.current = requestAnimationFrame(() => {
          const columns = (rowRef.current as HTMLDivElement).children;
          const widths = calculateColumnsWidths(columns);
          setWidths(widths);
        });
      }),
    [],
  );

  /** Следит за изменением размеров контейнера (при этом будут меняться ширины ячеек) */
  React.useEffect(() => {
    const div = containerRef.current as HTMLDivElement;

    ro.observe(div);

    return () => {
      cancelAnimationFrame(animationFrameRef.current);
      ro.disconnect();
    };
  }, [ro]);

  return { widths, containerRef, rowRef };
};

function calculateColumnsWidths(columns: HTMLCollection) {
  return Array.from(columns).map(col => col.getBoundingClientRect().width);
}
